import {z} from "zod";
import {
  ReachTrigger,
  ReachTriggerPayload,
  TriggerCondition,
  TriggerInteractionType,
  TriggerStatus,
} from "../../apis/requests/triggers/types";

export const TRIGGER_INTERACTION_TYPES = [
  "PAYMENT_FAILURE",
  "PAYMENT_SUCCESS",
  "ACCOUNT_RESOLVED",
] as const satisfies readonly TriggerInteractionType[];

export const TRIGGER_STATUSES = ["active", "draft", "paused"] as const satisfies readonly TriggerStatus[];

export const DEFAULT_CONDITION: TriggerCondition = {
  name: "Default",
  is_default: true,
  locked: false,
  match_mode: "all",
  rules: [],
  outcome: "send",
  email_template_id: null,
  text_template_id: null,
  timing: "working_hours",
};

export const EMPTY_CONDITION: TriggerCondition = {...DEFAULT_CONDITION, name: "", is_default: false};

export const triggerFormSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
  description: z.string(),
  status: z.enum(TRIGGER_STATUSES),
  interaction_type: z.enum(TRIGGER_INTERACTION_TYPES),
  conditions: z.array(z.custom<TriggerCondition>()),
});

export type TriggerFormValues = z.infer<typeof triggerFormSchema>;

export const EMPTY_TRIGGER: TriggerFormValues = {
  name: "",
  description: "",
  status: "draft",
  interaction_type: "PAYMENT_FAILURE",
  conditions: [DEFAULT_CONDITION],
};

export const toTriggerPayload = (values: TriggerFormValues): ReachTriggerPayload => ({
  name: values.name.trim(),
  description: values.description.trim() || null,
  status: values.status,
  interaction_type: values.interaction_type,
  conditions: values.conditions,
});

export const toFormValues = (trigger: ReachTrigger): TriggerFormValues => ({
  name: trigger.name,
  description: trigger.description ?? "",
  status: trigger.status,
  interaction_type: trigger.interaction_type,
  conditions: trigger.conditions,
});
